import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, FormControl, Grid, TextField } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  sectionTitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.00rem',
      fontWeight: 600,
      margin: '8px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.10rem',
      fontWeight: 600,
      margin: '15px 0',
    },
  },
  sectionSubTitle: {
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.80rem',
      fontWeight: 600,
      margin: '2px 0',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.90rem',
      fontWeight: 600,
      margin: '5px 0',
    },
  },
  sectionSpacer: {
    height: 50,
    padding: '10px 0',
  },
  rowSpacer: {
    height: 30,
  },
  textRowSpacer: {
    [theme.breakpoints.up('sm')]: {
      height: 50,
    },
  },
  textRowLabelSpacer: {
    [theme.breakpoints.down('md')]: {
      height: 30,
      paddingTop: 5,
    },
    [theme.breakpoints.up('md')]: {
      height: 50,
      paddingTop: 8,
    },
  },
  [theme.breakpoints.down('xs')]: {
    textField: {
      fontSize: '0.75rem',
    },
    root: {
      '& .MuiFormLabel-root': {
        fontSize: '0.75rem',
      },
    },
  },
  radioLabel: {
    fontSize: '0.85rem',
    fontWeight: 500,
    '& svg': {
      width: '1.25rem',
      height: '1.25rem',
    },
  },
  datePickerRowSpacer: {
    height: 50,
    paddingTop: 8,
    marginBottom: 10,
  },
  datepicker: {
    width: '230px',
    '& .MuiFilledInput-root': {
      background: 'rgb(255, 255, 255)',
    },
  },
  textRowLargeLabelSpacer: {
    [theme.breakpoints.down('sm')]: {
      height: 60,
      paddingTop: 5,
    },
    [theme.breakpoints.up('sm')]: {
      height: 50,
      paddingTop: 8,
    },
  },
  bold: {
    fontWeight: 600,
  },
  subtleBold: {
    fontWeight: 500,
  },
  subtleBoldLabel: {
    fontWeight: 500,
    fontSize: '0.95rem',
  },
  printedContent: {
    '@media print': {
      marginBottom: 10,
    },
    '@media screen': {
      display: 'none',
    },
  },
  unprintedContent: {
    '@media print': {
      display: 'none',
    },
    '@media screen': {},
  },
  alignPrintedContent: {
    lineHeight: '25px',
    verticalAlign: 'top',
  },
}));

export default function SpiritualInformationV2(props) {
  const { form, setForm, disabled } = props;

  const classes = styles();

  return (
    <Box sx={{ width: '90%' }}>
      <Grid container direction="row" className={classes.sectionSpacer}>
        <Grid item xs={12} align="left">
          <section align="left" className={classes.sectionSubTitle}>
            Spiritual/Religious Participation Plan for Post-Graduation (Church, bible study, etc.)
          </section>
        </Grid>
      </Grid>
      <Grid container direction="row" className={classes.unprintedContent}>
        <Grid item xs={false} md={1} lg={1} />
        <Grid item xs={12} md={6} lg={3} className={classes.textRowLabelSpacer}>
          <label>What church or religious center would you attend after leaving Boys Town?</label>
        </Grid>
        <Grid item xs={12} md={6} lg={8} className={classes.textRowSpacer} style={{ marginTop: '5px' }}>
          <FormControl fullWidth>
            <TextField
              id="auto-insurance-coverage"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.church}
              onChange={(event) => setForm({ ...form, church: event.target.value })}
              disabled={disabled}
              InputProps={{ classes: { input: classes.textField } }}
              inputProps={{ maxLength: 100 }}
              className={classes.root}
            />
          </FormControl>
        </Grid>
      </Grid>
      <div className={classes.printedContent}>
        <Grid container direction="row" className={classes.printedContent}>
          <Grid item xs={6}>
            <label className={classes.alignPrintedContent}>What church or religious center would you attend after leaving Boys Town?</label>
          </Grid>
          <Grid item xs={6}>
            <summary className={classes.alignPrintedContent}>{form.church || null}</summary>
          </Grid>
        </Grid>
      </div>
    </Box>
  );
}

SpiritualInformationV2.propTypes = {
  form: PropTypes.object,
  setForm: PropTypes.func,
  disabled: PropTypes.bool,
};
